import { IRouteProps } from 'modules';
import { lazy } from 'react';
export const GrowthHackRoute: IRouteProps = {
  path: '/genesis-drop',
  component: lazy(() => import('./GrowthHack')),
  exact: true,
  name: 'genesis-drop',
};
export default GrowthHackRoute;
